import * as React from 'react';
import type { SVGProps } from 'react';
const SvgInfo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <circle cx={8} cy={8} r={8} />
    <path
      fill="#fff"
      d="M9 4.2a1 1 0 1 1-1.999 0A1 1 0 0 1 9 4.2M7.2 7.2a.8.8 0 1 1 1.6 0v4.4a.8.8 0 0 1-1.6 0z"
    />
  </svg>
);
export default SvgInfo;
